export default theme => ({
    cellGrey: {
        backgroundColor:"#2363A9", color:"white", borderBottom:"1px white solid", borderRight:"1px white solid", borderLeft:"1px white solid",lineHeight:"0.5", padding:"2px",textAlign:"center",
    },
    typoMont:{
        fontFamily: 'Montserrat',
        fontSize:"0.6rem",
        fontWeight:"bold",
    },
    Mont:{
        fontFamily: 'Montserrat',
    },
    cell: {
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhite: {
        backgroundColor:"#2363A9",
        borderRight:"1px white solid",
        color:"white",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    
    cellWhiteRightLeft: {
        borderRight:"1px rgba(128, 128, 128, 0.5) solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteRightLeftBottom: {
        borderRight:"1px rgba(128, 128, 128, 0.5) solid",    
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteRight: {
        borderRight:"1px rgba(128, 128, 128, 0.5) solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteRightBottom: {
        borderRight:"1px rgba(128, 128, 128, 0.5) solid",
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellWhiteBottom: {
        textAlign:"center",
        lineHeight:"0.5",
        padding:"2px"
    },
    cellBlueGrey:{
        backgroundColor:"#ff7800", color:"white", border:"1px solid",textAlign:"center",lineHeight:"0.5",
        padding:"2px"
    }
    
  });


// WEBPACK FOOTER //
// ./src/layouts/components/content/Movistar/styles.jsx